const pages = {
  index: '/transactions',
  details: '/transactions/:id',
};

export default pages;
